import { useEffect, useState } from "react";
import api from "../../services/api";
import CheckInMeeting from "./check-in-meeting/CheckInMeeting";
import CheckInEvent from "./check-event/CheckInEvent";
import IEventDetail from "../../models/IEventDetail";
import { authenticationService } from "../../services/auth.service";

interface Params {}

export default function CheckIn(props: Params) {
  const {} = props;

  const [eventDetail, setEventDetail] = useState<IEventDetail>();
  const [cssClass, setCssClass] = useState<string>('uk-width-1@m');

  useEffect(() => {
    async function init() {
      if (authenticationService.isRoutine()) {
        const { data } = await api.get("/events/active");
  
        setEventDetail(data);
        if (!authenticationService.isRoutine()) {
          setCssClass('uk-width-1-2@m');
        }
      }      
    }
    
    init();
  }, []);

  return (
    <div className="uk-grid uk-flex">
      <div className={cssClass}>
        <CheckInMeeting />
      </div>
      {
        (authenticationService.isRoutine() && eventDetail) &&
          <div className="uk-width-1@m uk-margin-xsmall-top">
            <CheckInEvent idEvent={eventDetail?.id ?? 0} nameEvent={eventDetail?.name}  />
          </div>
      }
    </div>
  );
}
